export default [
  {
    path: '/mini-kasko',
    name: 'miniKaskoCalculator',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
    },
    component: () => import('../pages/insurance-mini-kasko-page/calculator.vue'),
  },
  {
    path: '/mini-kasko-offers',
    name: 'miniKaskoOffers',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
    },
    component: () => import('../pages/insurance-mini-kasko-page/results.vue'),
  },
  {
    path: '/mini-kasko-orders/:orderId?',
    name: 'miniKaskoOrder',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
    },
    component: () => import('../pages/insurance-mini-kasko-page/order.vue'),
  },
];
